export default "__VITE_ASSET__Cua6z4Fj__"